import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'
import '@/style/index.scss'
import './plugins/element.js'
import './plugins/vant.js'
import './plugins/vab.js'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/encryptAes'
import { formatNumber} from "@/utils/formatNumber";
import AMapJS from 'amap-js';
import './utils/hasprimi'
//
// import VConsole from 'vconsole';
// new VConsole();
// 定义全局过滤器
// Vue.filter('addSpaces', function (number) {
//   if (number) {
//     // 将数字转换为字符串
//     let strNumber = number.toString();
//
//     // 使用正则表达式在数字字符串中插入逗号
//     return strNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//
//   }else{
//     return  0 ;
//   }
// });
// 在main.js文件钟准备一个滚动加载指令
Vue.directive('loadmore', {
  bind(el, binding) {
    const selectWrap = el.querySelector('.el-table__body-wrapper')
    selectWrap.addEventListener('scroll', function() {
      let sign = 0
      const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
      if (scrollDistance <= sign) {
        binding.value()
      }
    })
  }
})
Vue.prototype.$formatNumber = formatNumber; // 挂载方法到 Vue 的原型上


import md5 from 'js-md5';
Vue.prototype.$md5 = md5;


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
